<template>
<div class="no_limit">
        <OtherHead :tipText="$t('没有访问权限')"></OtherHead>
        <div class="empty_content">
            <img src="@/assets/img/share/icon_apply_no_auth.png" alt=""/>
            <div class="empty_text">{{$t("没有访问权限")}}</div>
            <div class="empty_desc">{{$t("此页面继承了上级页面的限制，您无法访问")}}<br/>{{$t("请联系分享此页面的人开通权限")}}</div>
        </div>
    </div>
</template>

<script lang="ts">
import OtherHead from './OtherHead.vue'
export default {
    name: 'no_limit_no_apply',
    components: {
        OtherHead
    },
    data() {
        return {
        }
    },
    computed: {

    },
    methods: {

    },
}
</script>

<style lang="scss" scoped>
.no_limit {
    flex: 1;
    display: flex;
    flex-direction: column;

    .empty_content {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;

        img {
            width: 127px;
        }

        .empty_text {
            margin-top: 16px;
            font-family: PingFangSC-Medium;
            font-weight: 500;
            font-size: 18px;
            color: #121317;
            letter-spacing: 0;
        }

        .empty_desc {
            margin-top: 16px;
            font-family: PingFangSC-Regular;
            font-weight: 400;
            font-size: 14px;
            color: #A5A7B3;
            text-align: center;
            line-height: 20px;
        }
    }
}
</style>
